import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnSelectField"], {
        modelValue: $setup.selectedItem,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.selectedItem) = $event)),
        items: $props.items,
        "static-id": $setup.selectId,
        class: "mt-5 no-padding type-select",
        "item-title": "text",
        "item-value": "value"
    }, null, 8 /* PROPS */, ["modelValue", "items", "static-id"]));
}
